export default class extends Controller {
  static targets = ['collapse']

  toggle(){
    this.element.classList.toggle('mm-active')
    this.collapseTarget.classList.toggle('show')
  }
}
